import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "error", "elements"];
import { Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import theme from "../../../../theme/theme";
dayjs.extend(utc);
export var FormDateRangePicker = function (props) {
    var _elements$, _elements$2;
    var value = props.value, onChange = props.onChange, error = props.error, elements = props.elements, others = _objectWithoutProperties(props, _excluded);
    if (!(elements !== null && elements !== void 0 && elements.length))
        return null;
    var slotsLabels = [(_elements$ = elements[0]) === null || _elements$ === void 0 ? void 0 : _elements$.label, (_elements$2 = elements[1]) === null || _elements$2 === void 0 ? void 0 : _elements$2.label];
    var errorText = [];
    if (error && error[0])
        errorText.push("".concat(slotsLabels[0], " ").concat(error[0]));
    if (error && error[1])
        errorText.push("".concat(slotsLabels[1], " ").concat(error[1]));
    var combinedErrorText = errorText.join(' & ');
    var handleDateChange = function (date) {
        var _dayjs$utc, _dayjs$utc2;
        var startDate = date !== null && date !== void 0 && date[0] ? (_dayjs$utc = dayjs.utc(date[0])) === null || _dayjs$utc === void 0 ? void 0 : _dayjs$utc.format() : null;
        var endDate = date !== null && date !== void 0 && date[1] ? (_dayjs$utc2 = dayjs.utc(date[1])) === null || _dayjs$utc2 === void 0 ? void 0 : _dayjs$utc2.format() : null;
        if (onChange) {
            onChange(null, startDate, elements[0]);
            onChange(null, endDate, elements[1]);
        }
    };
    return /*#__PURE__*/ React.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs
    }, /*#__PURE__*/ React.createElement(DateRangePicker, _extends({
        value: (value === null || value === void 0 ? void 0 : value.length) && [value[0] ? dayjs(value[0]) : null, value[1] ? dayjs(value[1]) : null],
        timezone: "system",
        formatDensity: "spacious",
        desktopModeMediaQuery: theme.breakpoints.up('sm'),
        slotProps: {
            textField: {
                size: "small",
                error: Boolean(combinedErrorText)
            },
            fieldSeparator: {
                display: 'none'
            }
        },
        sx: {
            my: 1
        },
        onChange: handleDateChange
    }, others)), combinedErrorText && /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        color: "error",
        mt: 0.5
    }, combinedErrorText));
};
